import * as React from "react"
import Svg, { Defs, G, Path } from "react-native-svg"

function DownloadIcon(props) {
  return (
    <Svg viewBox="0 0 206.34 166.13" {...props}>
      <Defs></Defs>
      <G id="prefix__Layer_2" data-name="Layer 2">
        <G id="prefix__Layer_1-2" data-name="Layer 1">
          <Path
            className="prefix__cls-1"
            d="M103.09 90.93V3.36M63.85 83.13L98.28 121a8 8 0 0011.33 0L143 83.13"
          />
          <Path
            className="prefix__cls-1"
            d="M3.36 103.28v51.46a8.06 8.06 0 008 8H194.9a8.07 8.07 0 008.08-8v-51.46"
          />
        </G>
      </G>
    </Svg>
  )
}

export default DownloadIcon
